import React, { forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CollegePills from '../../components/collegePills';
import { removeCollegePill } from '@store/collegePill/actions';

interface CollegePillsProps {
  children?: React.ReactNode;
}

export type Ref = HTMLInputElement;

const CollegePillsContainer = forwardRef<Ref, CollegePillsProps>((_, ref) => {
  const dispatch = useDispatch();
  const pills = useSelector((store: any) => store.collegePill);

  return (
    <CollegePills
      pills={pills}
      removeCollegePill={(pill: any) => {
        const lastIndex = pills.length - 1;
        const matchingObject = pills.find(
          (obj: any) => obj.value === pill.value
        );
        if (pills.indexOf(matchingObject) === lastIndex) {
          ref?.current?.focus();
        }
        dispatch(removeCollegePill({ value: pill.value }));
      }}
    />
  );
});

export default CollegePillsContainer;
try {
    // @ts-ignore
    collegePills.displayName = "collegePills";
    // @ts-ignore
    collegePills.__docgenInfo = { "description": "", "displayName": "collegePills", "props": { "ref": { "defaultValue": null, "description": "", "name": "ref", "required": false, "type": { "name": "Ref<HTMLInputElement>" } }, "key": { "defaultValue": null, "description": "", "name": "key", "required": false, "type": { "name": "string | number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/collegePills/collegePills.tsx#collegePills"] = { docgenInfo: collegePills.__docgenInfo, name: "collegePills", path: "src/containers/collegePills/collegePills.tsx#collegePills" };
}
catch (__react_docgen_typescript_loader_error) { }